import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard';
import TutorMode from './components/TutorMode';
import TutorSetup from './components/TutorSetup';
import ExamMode from './components/ExamMode';
import ExamResults from './components/ExamResults';
import ExamReview from './components/ExamReview';
import TutorReport from './components/TutorReport';
import ExamReport from './components/ExamReport';
import ExamHistory from './components/ExamHistory';
import AdminAddUser from './components/Admin/AdminAddUser';
import AdminApprovals from './components/Admin/AdminApprovals';
import AdminQuestions from './components/Admin/AdminQuestions';
import AdminBulkAddUsers from './components/Admin/AdminBulkAddUsers'; // new import
import CaseStudyList from './components/CaseStudyList';
import CaseStudyMode from './components/CaseStudyMode';
import CaseStudyReport from './components/CaseStudyReport';
import CaseStudyReview from './components/CaseStudyReview';

function App() {
  const { token, user } = useSelector((state) => state.auth);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!token ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/register" element={!token ? <Register /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/tutor/setup" element={token ? <TutorSetup /> : <Navigate to="/login" />} />
        <Route path="/tutor" element={token ? <TutorMode /> : <Navigate to="/login" />} />
        <Route path="/tutor/report" element={token ? <TutorReport /> : <Navigate to="/login" />} />
        <Route path="/exam" element={token ? <ExamMode /> : <Navigate to="/login" />} />
        <Route path="/exam/results" element={token ? <ExamResults /> : <Navigate to="/login" />} />
        <Route path="/exam/review" element={token ? <ExamReview /> : <Navigate to="/login" />} />
        <Route path="/exam/report/:sessionId" element={token ? <ExamReport /> : <Navigate to="/login" />} />
        <Route path="/exam/history" element={token ? <ExamHistory /> : <Navigate to="/login" />} />
        
        {/* Case study routes */}
        <Route path="/case-studies" element={token ? <CaseStudyList /> : <Navigate to="/login" />} />
        <Route path="/case-study/:id" element={token ? <CaseStudyMode /> : <Navigate to="/login" />} />
        <Route path="/case-study/report" element={token ? <CaseStudyReport /> : <Navigate to="/login" />} />
        <Route path="/case-study/review/:id" element={token ? <CaseStudyReview /> : <Navigate to="/login" />} />
        
        {/* Admin routes – consider using user?.is_admin for consistency */}
        <Route 
          path="/admin/add-user" 
          element={token && user?.username === 'admin' ? <AdminAddUser /> : <Navigate to="/dashboard" />} 
        />
        <Route 
          path="/admin/approvals" 
          element={token && user?.username === 'admin' ? <AdminApprovals /> : <Navigate to="/dashboard" />} 
        />
        <Route 
          path="/admin/questions" 
          element={token && user?.username === 'admin' ? <AdminQuestions /> : <Navigate to="/dashboard" />} 
        />
        {/* New bulk-add route using is_admin (recommended) */}
        <Route 
          path="/admin/bulk-add-users" 
          element={token && user?.is_admin ? <AdminBulkAddUsers /> : <Navigate to="/dashboard" />} 
        />
        
        <Route path="/" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;